import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import {Button} from "react-bootstrap";
import * as acc from "accounting";
import ReactTooltip from "react-tooltip";

export default class BiletyMiesieczne extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
        }
    }

    checkWazna(item) {
        if (item.ostWaznyOd === null && item.ostWaznyDo === null) {
            return 'Brak danych'
        } else {
            return item.ostWaznyOd.substr(0, 10) + ' - ' + item.ostWaznyDo.substr(0, 10)
        }
    }

    checkCena(item) {
        if (item.ostCena === null) {
            return 'Brak danych'
        } else {
            return acc.formatMoney(item.ostCena, {
                symbol: "zł",
                format: "%v %s"
            })
        }
    }

    checkKierunek(kierunek) {
        switch (kierunek) {
            case 1:
                return 'w jedną stronę';
            case 2:
                return 'w obie strony'
        }
    }

    render() {
        return <div>
            {this.state.data !== undefined && this.state.data !== null && this.state.data.length !== 0 ?
                <div>
                    <b>Twoje karty:</b>
                    {this.state.data.slice(0).map((item, index) => {
                        return (
                            <div>
                                <div className="wynik biletyMiesieczne">
                                    <div className="row">
                                        <div className="col-10">
                                            <div className="row">
                                                <div className="col-4">
                                                    {item.tylkoEkarta ?
                                                        <div>Numer <b>e</b>-karty: {item.nrKarty}</div> : <div>Numer
                                                            karty: <b>{item.nrKarty === null ? '-' : item.nrKarty}</b>
                                                        </div>}
                                                </div>
                                                <div className="col-8" style={{marginRight: 0, paddingRight: 0}}>
                                                    <div>Ważna: <b>{this.checkWazna(item)}</b></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2"></div>
                                        <div className="col-10">
                                            <div className="row">
                                                <div className="col-sm-4 miejscowosciOdDoMies">
                                                    {item.nazMiOd} - {item.nazMiDo}
                                                </div>
                                                <div className="col-sm-4 waznyMies">
                                                    <div>
                                                        Status: {item.status === 'NOWA' ?
                                                        <span style={{color: '#17a2b8'}}>{item.status}</span> : <span>
                                                            {item.status === 'ZWROCONA' ?
                                                                <span style={{color: '#dc3545'}}>{item.status}</span> :
                                                                <span
                                                                    style={{color: '#28a745'}}>{item.status}</span>}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 kierunekMies">
                                                    <div><i
                                                        className="fa fa-exchange"> </i> {this.checkKierunek(item.kierunek)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4 trasaMies">
                                                    Trasa: <span>{item.nazTr}</span>
                                                </div>
                                                <div className="col-sm-4 typMies">
                                                    Typ: <span>{item.nazZniz}</span>
                                                </div>
                                                <div className="col-sm-4 typMies">
                                                    Cena: <span>{this.checkCena(item)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2 widthMobilkaCol2">
                                            <div className="doladuj">
                                                {item.status === 'NOWA' ? <div>
                                                        <ReactTooltip id={(item.idKa).toString()}>
                                                            <div className="text-left">
                                                                Karta nie została jeszcze zweryfikowana
                                                            </div>
                                                        </ReactTooltip>
                                                        <div data-tip
                                                             data-for={(item.idKa).toString()}
                                                             data-place="bottom">
                                                            <Button bsStyle={'success'} disabled={true}>Wybierz</Button>
                                                        </div>
                                                    </div>
                                                    :
                                                    <Button bsStyle={'success'} onClick={() => {
                                                        this.props.item(item);
                                                        this.props.pokazSzczegoly()
                                                    }}>Wybierz</Button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div> :
                <div style={{paddingTop: 25}}>
                    <center><h3>Brak biletów</h3></center>
                </div>
            }
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyMiesiecznePokaz.js